import React from 'react'
import styled from 'styled-components'

const Container = styled.div`

    margin: 2rem 0rem; 

    @media (min-width: 768px) {

        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;

    }

    div {
        margin-bottom: 2rem;
    }


    @media (min-width: 768px) {

        div {
            margin-bottom: 0rem;
        }

    }

    h5 {
        font-weight: bold;
    }

    h5, p {
        color: black!important;
    }
`

// const LastExperience = styled.div`
    
//     grid-column: 1 / 3;

// `

const Experience = () => {
    return ( 
        <div className="counter">
                
            <div className="about_title">
                <h3>Experience</h3>
            </div>

            <Container>

            <div className="list_inner">
                        
                        <h5>RookMotion</h5>
                        <span>RookMotion</span>
    
                        <p>
                            RookMotion is a SaaS platform mainly focus to personal trainers, fitness people or gyms, in their web platform the coach is able to see who is training with him/her, see the performance like burned calories, effort and heart rate of the last training of the trainee.
                        </p>
    
                        <p>
                            In the other hand the coaches are able to have realtime workouts and see the same data burned calories, effort and heart rate but in realtime this help the coach to augment the difficultly of the workout or vice versa 
                        </p>
    
                        <p>
                            I worked as a <b>React Developer with TypeScript</b>, implementing Context API to manage the status of the app, <b>axios</b> to connect to the server by a REST API, and the components are coded with <b>Tailwind, Material UI, styled components and pure CSS</b>
                        </p>
    
                        <p>
                            To manage the realtime stuff we implemented <b>Pusher</b> because the codification was very clean and easy to use.
                        </p>
    
                        <p>
                            As part of the migration I implemented <b>XState</b> to controle states of the application as loading, failure or success. This allowed me to manage the logic separated of styles as well as do different actions in each state like transitions, alerts or consume some endpoints of the API
                        </p>
    
                    </div>

                <div className="list_inner">
                        
                    <h5>EknoWifi</h5>
                    <span>Corebooks</span>

                    <p>
                        I worked in the project Eknowifi as a <b> fronted developer </b> of Corebooks, in my stay in corebooks we was working in a motor of statistics, in other words we was working in a way to present a series of charts, tables, timelines, in order to show the improvements or decay of the visits of the constumers, this measurements was collected by analyzing the traffic of the access points.
                    </p>

                    <p>
                        My work was to manage the information collected and display using the guide lines that they gave me by the designers, in other hand I worked all the code in <b>JavaScript</b>, <b>React</b> and <b>Pure CSS</b>
                    </p>

                </div>

                <div className="list_inner">
                        
                    <h5>Freelance</h5>
                    <span>Alpha</span>

                    <p>
                        I started a little start up with the purpose to help small and medium business with their projects, like CRM's, landing pages, mobile apps, etc, the purpose is to give technical guiance to this kind of enterprenuers that want a IT solutions in their products that are close to be lanched.
                    </p>

                    <p>
                        We launch a web app to the main purpose to promote the local consumption, promoting the products and services that are made in my city.
                    </p>

                    <p>
                        One of the most important client it's <b>El Miaura</b> this is a veterinary, we made a CRM to manage their clients, products, and sales
                    </p>

                    <p>
                        I work as a full stack developer, developing Web Apps, APIs ( <b>REST</b> and <b>GraphQL</b> ) and Mobile apps, the front of the apps according to the case could be <b>React, React Native, Java Script and pure CSS.</b>
                    </p>

                </div>

                <div className="list_inner">
                        
                    <h5>Cero Lavado</h5>
                    <span>Apdevs</span>

                    <p>
                        We worked in a mobile app for car wash with the propuse to request a personal of the carwash to clean your car at your home, office or any where you are, we worked in the first release of the app, the app implements maps, shopping lists, a timeline with the orders.
                    </p>

                    <p>
                        I worked as a <b>React Native Developer</b>, implementing Context API to manage the status of the app, <b>axios</b> to connect to the server by a REST API, and the components are coded with <b>pure CSS and Styled Components (Sass)</b>
                    </p>

                </div>


            </Container>
        
        </div>
    );
}
 
export default Experience;